// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/likeDark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/likeActiv.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-items: start;
}

.card__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border: 1px solid #5e5d5b;
}

.card__photo {
  width: 270px;
  height: 270px;
  background-position: center;
  object-fit: contain;
  cursor: zoom-in;
}

.card__block {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.card__block-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.card__title {
  font-family: Oswald-Light, sans-serif;
  font-size: 0.6em;
  font-weight: 300;
  margin: 0 2px;
  padding: 1px 0;
  text-align: start;
}

.card__block-description {
  display: flex;
  align-items: center;
}

.card__duration {
  font-family: Oswald-Light, sans-serif;
  font-size: 0.5em;
  font-weight: 300;
  margin: 0 2px;
  padding: 0 0 5px 0;
}

.card__description {
  font-family: Oswald-Light, sans-serif;
  font-weight: 300;
  font-size: 0.5em;
  margin: 0 12px;
  padding: 0 0 5px 0;
}

.card__sold {
  font-family: Oswald-Light, sans-serif;
  font-weight: 300;
  font-size: 0.5em;
  margin: 0;
  padding: 0 0 5px 0;
}

.card__btn-like {
  width: 1.2em;
  height: 2em;
  border: 0;
  padding: 0;
  margin: 0 2px;
  outline-style: none;
  background-color: #073042;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}

.card__btn-likeActiv {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
}

.card__btn-like.card__btn-likeActiv {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
}

@media screen and (max-width: 610px) {
  .card__title {
    font-size: 1em;
  }
  .card__description {
    font-size: 0.8em;
    padding: 0 0 8px 0;
  }
  .card__btn-like {
    width: 2em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Cards/Cards.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2EAAoE;AACtE;;AAEA;EACE,2EAAqE;AACvE;;AAEA;EACE,2EAAqE;AACvE;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".card {\r\n  width: 100%;\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  justify-items: start;\r\n}\r\n\r\n.card__wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 5px;\r\n  border: 1px solid #5e5d5b;\r\n}\r\n\r\n.card__photo {\r\n  width: 270px;\r\n  height: 270px;\r\n  background-position: center;\r\n  object-fit: contain;\r\n  cursor: zoom-in;\r\n}\r\n\r\n.card__block {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.card__block-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.card__title {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.6em;\r\n  font-weight: 300;\r\n  margin: 0 2px;\r\n  padding: 1px 0;\r\n  text-align: start;\r\n}\r\n\r\n.card__block-description {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.card__duration {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.5em;\r\n  font-weight: 300;\r\n  margin: 0 2px;\r\n  padding: 0 0 5px 0;\r\n}\r\n\r\n.card__description {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-weight: 300;\r\n  font-size: 0.5em;\r\n  margin: 0 12px;\r\n  padding: 0 0 5px 0;\r\n}\r\n\r\n.card__sold {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-weight: 300;\r\n  font-size: 0.5em;\r\n  margin: 0;\r\n  padding: 0 0 5px 0;\r\n}\r\n\r\n.card__btn-like {\r\n  width: 1.2em;\r\n  height: 2em;\r\n  border: 0;\r\n  padding: 0;\r\n  margin: 0 2px;\r\n  outline-style: none;\r\n  background-color: #073042;\r\n  background: url(\"../../images/likeDark.svg\") no-repeat center center;\r\n}\r\n\r\n.card__btn-likeActiv {\r\n  background: url(\"../../images/likeActiv.svg\") no-repeat center center;\r\n}\r\n\r\n.card__btn-like.card__btn-likeActiv {\r\n  background: url(\"../../images/likeActiv.svg\") no-repeat center center;\r\n}\r\n\r\n@media screen and (max-width: 610px) {\r\n  .card__title {\r\n    font-size: 1em;\r\n  }\r\n  .card__description {\r\n    font-size: 0.8em;\r\n    padding: 0 0 8px 0;\r\n  }\r\n  .card__btn-like {\r\n    width: 2em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
